<template>
  <div class="device-mockup-container" :style="{ transform: `scale(${scale})` }">
    <!-- Phone Mockup -->
    <div v-if="deviceType === 'phone'" class="device-mockup">
      <div
        class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl">
        <div class="h-[24px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[54px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg">
        </div>
        <div class="h-[48px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg"></div>
        <div class="rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800">
          <SimpleSecureImage
            v-if="wallpaperId"
            :image-url="displayWallpaperUrl"
            :wallpaper-id="wallpaperId"
            :is-preview="true"
            :force-autoplay="true"
            :muted="true"
            :loop="true"
            :playsinline="true"
            :alt="name || 'Phone wallpaper'"
            :container-class="'w-[222px] h-[422px] rounded-[2rem]'"
            :image-class="getImageClasses('w-[222px] h-[422px]')"
            :target-aspect="222/422"
            :target-width="222"
            :target-height="422"
            @click="$emit('click')"
          />
          <div v-else-if="wallpaper" :style="getBackgroundStyle()"
            :class="getImageClasses('w-[222px] h-[422px]')" @click="$emit('click')"></div>
          <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
          <div v-else class="w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]" @click="$emit('click')">
            <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Phone' }}</p>
    </div>

    <!-- iPhone 12 Mockup -->
    <div v-else-if="deviceType === 'iphone'" class="device-mockup">
      <div
        class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl">
        <!-- iPhone 12 Notch - More prominent and realistic -->
        <div class="w-[100px] h-[20px] bg-gray-900 top-0 rounded-b-[1.2rem] left-1/2 -translate-x-1/2 absolute z-20 shadow-inner border-b-2 border-gray-700"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg"></div>
        <div class="h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg"></div>
        <div class="rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800">
          <SimpleSecureImage
            v-if="wallpaperId"
            :image-url="displayWallpaperUrl"
            :wallpaper-id="wallpaperId"
            :is-preview="true"
            :force-autoplay="true"
            :muted="true"
            :loop="true"
            :playsinline="true"
            :alt="name || 'iPhone wallpaper'"
            :container-class="'w-[222px] h-[422px] rounded-[2rem]'"
            :image-class="getImageClasses('w-[222px] h-[422px]')"
            :target-aspect="222/422"
            :target-width="222"
            :target-height="422"
            @click="$emit('click')"
          />
          <div v-else-if="wallpaper" :style="getBackgroundStyle()"
            :class="getImageClasses('w-[222px] h-[422px]')" @click="$emit('click')"></div>
          <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
          <div v-else class="w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]" @click="$emit('click')">
            <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'iPhone 12' }}</p>
    </div>

    <!-- iPhone Pro Mockup -->
    <div v-else-if="deviceType === 'iphone-pro'" class="device-mockup">
      <div
        class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[450px] w-[250px] shadow-xl">
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg"></div>
        <div class="h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg"></div>
        <div class="rounded-[2rem] overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800">
          <SimpleSecureImage
            v-if="wallpaperId"
            :image-url="displayWallpaperUrl"
            :wallpaper-id="wallpaperId"
            :is-preview="true"
            :force-autoplay="true"
            :muted="true"
            :loop="true"
            :playsinline="true"
            :alt="name || 'iPhone Pro wallpaper'"
            :container-class="'w-[222px] h-[422px] rounded-[2rem]'"
            :image-class="getImageClasses('w-[222px] h-[422px]')"
            :target-aspect="222/422"
            :target-width="222"
            :target-height="422"
            @click="$emit('click')"
          />
          <div v-else-if="wallpaper" :style="getBackgroundStyle()"
            :class="getImageClasses('w-[222px] h-[422px]')" @click="$emit('click')"></div>
          <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
          <div v-else class="w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]" @click="$emit('click')">
            <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
          </div>
        </div>
        <!-- Dynamic Island overlay on top of the screen area -->
        <div class="w-[80px] h-[24px] bg-gray-800 top-[8px] rounded-full left-1/2 -translate-x-1/2 absolute z-20 pointer-events-none"></div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'iPhone Pro' }}</p>
    </div>

    <!-- Android Mockup -->
    <div v-else-if="deviceType === 'android'" class="device-mockup">
      <div
        class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-xl h-[450px] w-[250px] shadow-xl">
        <div class="w-[120px] h-[14px] bg-gray-800 top-0 rounded-b-[1rem] left-1/2 -translate-x-1/2 absolute"></div>
        <div class="h-[24px] w-[3px] bg-gray-800 absolute -start-[17px] top-[54px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[93px] rounded-s-lg"></div>
        <div class="h-[34px] w-[3px] bg-gray-800 absolute -start-[17px] top-[133px] rounded-s-lg"></div>
        <div class="h-[48px] w-[3px] bg-gray-800 absolute -end-[17px] top-[106px] rounded-e-lg"></div>
        <div class="rounded-xl overflow-hidden w-[222px] h-[422px] bg-white dark:bg-gray-800">
          <SimpleSecureImage
            v-if="wallpaperId"
            :image-url="displayWallpaperUrl"
            :wallpaper-id="wallpaperId"
            :is-preview="true"
            :force-autoplay="true"
            :muted="true"
            :loop="true"
            :playsinline="true"
            :alt="name || 'Android wallpaper'"
            :container-class="'w-[222px] h-[422px] rounded-xl'"
            :image-class="getImageClasses('w-[222px] h-[422px]')"
            :target-aspect="222/422"
            :target-width="222"
            :target-height="422"
            @click="$emit('click')"
          />
          <div v-else-if="wallpaper" :style="getBackgroundStyle()"
            :class="getImageClasses('w-[222px] h-[422px]')" @click="$emit('click')"></div>
          <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
          <div v-else class="w-[222px] h-[422px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-xl" @click="$emit('click')">
            <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Android' }}</p>
    </div>

    <!-- Tablet Mockup -->
    <div v-else-if="deviceType === 'tablet'" class="device-mockup">
      <div
        class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[350px] w-[280px] md:h-[400px] md:w-[320px] shadow-xl">
        <div class="h-[24px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[50px] rounded-s-lg"></div>
        <div class="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[86px] rounded-s-lg"></div>
        <div class="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg">
        </div>
        <div class="h-[44px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[99px] rounded-e-lg"></div>
        <div
          class="rounded-[2rem] overflow-hidden h-[322px] w-[252px] md:h-[372px] md:w-[292px] bg-white dark:bg-gray-800">
          <SimpleSecureImage
            v-if="wallpaperId"
            :image-url="displayWallpaperUrl"
            :wallpaper-id="wallpaperId"
            :is-preview="true"
            :force-autoplay="true"
            :muted="true"
            :loop="true"
            :playsinline="true"
            :alt="name || 'Tablet wallpaper'"
            :container-class="'h-[322px] w-[252px] md:h-[372px] md:w-[292px] rounded-[2rem]'"
            :image-class="getImageClasses('h-[322px] w-[252px] md:h-[372px] md:w-[292px]')"
            :target-aspect="252/322"
            :target-width="292"
            :target-height="372"
            @click="$emit('click')"
          />
          <div v-else-if="wallpaper" :style="getBackgroundStyle()"
            :class="getImageClasses('h-[322px] w-[252px] md:h-[372px] md:w-[292px]')" @click="$emit('click')"></div>
          <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
          <div v-else class="h-[322px] w-[252px] md:h-[372px] md:w-[292px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]" @click="$emit('click')">
            <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Tablet' }}</p>
    </div>

    <!-- Laptop Mockup -->
    <div v-else-if="deviceType === 'laptop'" class="device-mockup">
      <div>
        <div
          class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] rounded-t-xl h-[150px] w-[240px] sm:h-[200px] sm:w-[320px] md:h-[320px] md:w-[520px] shadow-xl">
          <div
            class="rounded-lg overflow-hidden h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] bg-white dark:bg-gray-800">
            <SimpleSecureImage
              v-if="wallpaperId"
              :image-url="displayWallpaperUrl"
              :wallpaper-id="wallpaperId"
              :is-preview="true"
              :force-autoplay="true"
              :muted="true"
              :loop="true"
              :playsinline="true"
              :alt="name || 'Laptop wallpaper'"
              :container-class="'h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg'"
              :image-class="getImageClasses('h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg')"
              :target-aspect="504/304"
              :target-width="504"
              :target-height="304"
              @click="$emit('click')"
            />
            <div v-else-if="wallpaper" :style="getBackgroundStyle()"
              :class="getImageClasses('h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] rounded-lg')"
              @click="$emit('click')"></div>
            <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
            <div v-else class="h-[134px] w-[224px] sm:h-[184px] sm:w-[304px] md:h-[304px] md:w-[504px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-lg" @click="$emit('click')">
              <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
            </div>
          </div>
        </div>
        <div
          class="relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-xl rounded-t-sm h-[12px] w-[270px] sm:h-[15px] sm:w-[360px] md:h-[21px] md:w-[580px]">
          <div
            class="absolute left-1/2 top-0 -translate-x-1/2 rounded-b-xl w-[48px] h-[3px] sm:w-[64px] sm:h-[4px] md:w-[120px] md:h-[8px] bg-gray-800">
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Laptop' }}</p>
    </div>

    <!-- Desktop Mockup -->
    <div v-else-if="deviceType === 'desktop'" class="device-mockup">
      <div>
        <div
          class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] sm:border-[12px] md:border-[16px] rounded-t-xl h-[168px] w-[270px] sm:h-[224px] sm:w-[360px] md:h-[350px] md:w-[560px] shadow-xl">
          <div
            class="rounded-xl overflow-hidden h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px]">
            <SimpleSecureImage
              v-if="wallpaperId"
              :image-url="displayWallpaperUrl"
              :wallpaper-id="wallpaperId"
              :is-preview="true"
              :force-autoplay="true"
              :muted="true"
              :loop="true"
              :playsinline="true"
              :alt="name || 'Desktop wallpaper'"
              :container-class="'h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl'"
              :image-class="getImageClasses('h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl')"
              :target-aspect="528/318"
              :target-width="528"
              :target-height="318"
              @click="$emit('click')"
            />
            <div v-else-if="wallpaper" :style="getBackgroundStyle()"
              :class="getImageClasses('h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] rounded-xl')"
              @click="$emit('click')"></div>
            <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
            <div v-else class="h-[152px] w-[254px] sm:h-[200px] sm:w-[336px] md:h-[318px] md:w-[528px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-xl" @click="$emit('click')">
              <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
            </div>
          </div>
        </div>
        <div
          class="relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-xl h-[18px] w-[270px] sm:h-[25px] sm:w-[360px] md:h-[42px] md:w-[560px]">
        </div>
        <div
          class="relative mx-auto bg-gray-800 rounded-b-xl h-[36px] w-[72px] sm:h-[48px] sm:w-[96px] md:h-[80px] md:w-[160px]">
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Desktop' }}</p>
    </div>

    <!-- Ultrawide Monitor Mockup -->
    <div v-else-if="deviceType === 'ultrawide'" class="device-mockup">
      <div>
        <div
          class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[4px] sm:border-[6px] md:border-[12px] rounded-t-lg h-[90px] w-[270px] sm:h-[120px] sm:w-[360px] md:h-[250px] md:w-[750px] shadow-xl">
          <div
            class="rounded-lg overflow-hidden h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] bg-white dark:bg-gray-800">
            <SimpleSecureImage
              v-if="wallpaperId"
              :image-url="displayWallpaperUrl"
              :wallpaper-id="wallpaperId"
              :is-preview="true"
              :force-autoplay="true"
              :muted="true"
              :loop="true"
              :playsinline="true"
              :alt="name || 'Ultrawide wallpaper'"
              :container-class="'h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg'"
              :image-class="getImageClasses('h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg')"
              :target-aspect="726/226"
              :target-width="726"
              :target-height="226"
              @click="$emit('click')"
            />
            <div v-else-if="wallpaper" :style="getBackgroundStyle()"
              :class="getImageClasses('h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] rounded-lg')"
              @click="$emit('click')"></div>
            <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
            <div v-else class="h-[82px] w-[262px] sm:h-[108px] sm:w-[348px] md:h-[226px] md:w-[726px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-lg" @click="$emit('click')">
              <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
            </div>
          </div>
        </div>
        <div
          class="relative mx-auto bg-gray-900 dark:bg-gray-700 rounded-b-lg h-[12px] w-[270px] sm:h-[15px] sm:w-[360px] md:h-[30px] md:w-[750px]">
        </div>
        <div
          class="relative mx-auto bg-gray-800 rounded-b-lg h-[24px] w-[45px] sm:h-[30px] sm:w-[60px] md:h-[60px] md:w-[120px]">
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Ultrawide Monitor' }}
      </p>
    </div>

    <!-- Smart TV Mockup -->
    <div v-else-if="deviceType === 'tv'" class="device-mockup">
      <div>
        <div
          class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[8px] sm:border-[12px] md:border-[16px] rounded-lg h-[168px] w-[288px] sm:h-[224px] sm:w-[384px] md:h-[320px] md:w-[560px] shadow-xl">
          <div
            class="rounded-md overflow-hidden h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] bg-white dark:bg-gray-800">
            <SimpleSecureImage
              v-if="wallpaperId"
              :image-url="displayWallpaperUrl"
              :wallpaper-id="wallpaperId"
              :is-preview="true"
              :force-autoplay="true"
              :muted="true"
              :loop="true"
              :playsinline="true"
              :alt="name || 'TV wallpaper'"
              :container-class="'h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md'"
              :image-class="getImageClasses('h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md')"
              :target-aspect="528/288"
              :target-width="528"
              :target-height="288"
              @click="$emit('click')"
            />
            <div v-else-if="wallpaper" :style="getBackgroundStyle()"
              :class="getImageClasses('h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] rounded-md')"
              @click="$emit('click')"></div>
            <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
            <div v-else class="h-[152px] w-[272px] sm:h-[200px] sm:w-[360px] md:h-[288px] md:w-[528px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-md" @click="$emit('click')">
              <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
            </div>
          </div>
          <div
            class="absolute bottom-1 right-1 w-1.5 h-1.5 sm:bottom-2 sm:right-2 sm:w-2 sm:h-2 bg-red-500 rounded-full opacity-80">
          </div>
        </div>
        <div
          class="relative mx-auto bg-gray-800 dark:bg-gray-700 h-[5px] w-[288px] sm:h-[6px] sm:w-[384px] md:h-[10px] md:w-[560px]">
        </div>
        <div class="relative mx-auto">
          <div
            class="mx-auto bg-gray-800 dark:bg-gray-700 h-[7px] w-[192px] sm:h-[9px] sm:w-[256px] md:h-[15px] md:w-[380px] rounded-b-lg">
          </div>
          <div class="flex justify-between mx-auto w-[192px] sm:w-[256px] md:w-[380px] mt-1">
            <div
              class="bg-gray-800 dark:bg-gray-700 h-[15px] w-[36px] sm:h-[20px] sm:w-[48px] md:h-[30px] md:w-[80px] rounded-b-md">
            </div>
            <div
              class="bg-gray-800 dark:bg-gray-700 h-[15px] w-[36px] sm:h-[20px] sm:w-[48px] md:h-[30px] md:w-[80px] rounded-b-md">
            </div>
          </div>
        </div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Smart TV' }}</p>
    </div>

    <!-- Smartwatch Mockup -->
    <div v-else-if="deviceType === 'watch'" class="device-mockup">
      <div>
        <div class="relative mx-auto bg-gray-800 dark:bg-gray-700 rounded-t-[2.5rem] h-[63px] max-w-[133px]"></div>
        <div
          class="relative mx-auto border-gray-900 dark:bg-gray-800 dark:border-gray-800 border-[10px] rounded-[2.5rem] h-[213px] w-[208px] shadow-xl">
          <div class="h-[41px] w-[6px] bg-gray-800 dark:bg-gray-800 absolute -end-[16px] top-[40px] rounded-e-lg"></div>
          <div class="h-[32px] w-[6px] bg-gray-800 dark:bg-gray-800 absolute -end-[16px] top-[88px] rounded-e-lg"></div>
          <div class="rounded-[2rem] overflow-hidden h-[193px] w-[188px]">
            <SimpleSecureImage
              v-if="wallpaperId"
              :image-url="displayWallpaperUrl"
              :wallpaper-id="wallpaperId"
              :is-preview="true"
              :force-autoplay="true"
              :muted="true"
              :loop="true"
              :playsinline="true"
              :alt="name || 'Watch wallpaper'"
              :container-class="'h-[193px] w-[188px] rounded-[2rem]'"
              :image-class="getImageClasses('h-[193px] w-[188px]')"
              :target-aspect="188/193"
              :target-width="188"
              :target-height="193"
              @click="$emit('click')"
            />
            <div v-else-if="wallpaper" :style="getBackgroundStyle()"
              :class="getImageClasses('h-[193px] w-[188px]')" @click="$emit('click')"></div>
            <!-- SECURITY: Removed insecure fallback img tag that showed HD images -->
            <div v-else class="h-[193px] w-[188px] bg-gray-200 dark:bg-gray-700 flex items-center justify-center rounded-[2rem]" @click="$emit('click')">
              <span class="text-gray-500 dark:text-gray-400 text-sm">No Preview</span>
            </div>
          </div>
        </div>
        <div class="relative mx-auto bg-gray-800 dark:bg-gray-700 rounded-b-[2.5rem] h-[63px] max-w-[133px]"></div>
      </div>
      <p v-if="showLabel" class="text-center mt-4 text-gray-600 dark:text-gray-400">{{ name || 'Smartwatch' }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from 'vue'
const SimpleSecureImage = defineAsyncComponent(() => import('./SimpleSecureImage.vue'))

interface Props {
  deviceType: 'phone' | 'iphone' | 'iphone-pro' | 'android' | 'tablet' | 'laptop' | 'desktop' | 'ultrawide' | 'tv' | 'watch'
  wallpaper: string
  videoUrl?: string
  wallpaperId?: string
  resolution?: string
  name?: string
  showLabel?: boolean
  clickable?: boolean
  fitOption?: string
  scale?: number
}

interface Emits {
  (e: 'click'): void
}

const props = withDefaults(defineProps<Props>(), {
  showLabel: true,
  clickable: false,
  fitOption: 'fill',
  scale: 1
})

defineEmits<Emits>()

const displayWallpaperUrl = computed(() => {
  // Prefer a stored static poster/thumbnail for live wallpapers.
  // Fall back to the video URL only when no static preview exists.
  if (props.wallpaper?.trim()) {
    return props.wallpaper
  }

  return props.videoUrl?.trim() ? props.videoUrl : ''
})

// Function to get the appropriate CSS classes and styles based on fit option
const getImageClasses = (baseClasses: string) => {
  const fitClasses = {
    fill: 'object-cover',
    fit: 'object-contain',
    stretch: 'object-fill',
    tile: '', // Special handling for tile
    center: '', // Special handling for center
    span: 'object-cover',
    auto: '' // handled below
  }

  let fitClass = fitClasses[props.fitOption as keyof typeof fitClasses] || 'object-cover'

  if (props.fitOption === 'auto') {
    // Heuristic: use contain for very wide screens or square when image is likely portrait
    // If resolution is available, compute aspect ratio
    const res = props.resolution?.toLowerCase().split('x')
    if (res && res.length === 2) {
      const w = parseInt(res[0]) || 0
      const h = parseInt(res[1]) || 0
      const ratio = w && h ? w / h : 1
      const deviceRatioMap: Record<Props['deviceType'], number> = {
        phone: 9/19.5,
        iphone: 9/19.5,
        'iphone-pro': 9/19.5,
        android: 9/20,
        tablet: 4/3,
        laptop: 16/10,
        desktop: 16/9,
        ultrawide: 21/9,
        tv: 16/9,
        watch: 1
      }
      const target = deviceRatioMap[props.deviceType] || 1
      const diff = Math.abs(ratio - target)
      // If wallpaper is much narrower than screen (portrait on landscape), use contain
      fitClass = ratio < target ? 'object-contain' : (diff < 0.08 ? 'object-cover' : 'object-cover')
    } else {
      // Fallback: contain for landscape devices to avoid bad crops
      fitClass = ['laptop','desktop','ultrawide','tv'].includes(props.deviceType) ? 'object-contain' : 'object-cover'
    }
  }

  if (props.fitOption === 'tile' || props.fitOption === 'center') {
    return `${baseClasses} cursor-pointer hover:opacity-90 transition-opacity`
  }

  return `${baseClasses} ${fitClass} cursor-pointer hover:opacity-90 transition-opacity`
}



// Function to get appropriate tile size based on device type
const getTileSize = () => {
  const deviceSizes = {
    phone: 80,
    iphone: 80,
    'iphone-pro': 80,
    android: 80,
    tablet: 120,
    laptop: 150,
    desktop: 180,
    ultrawide: 200,
    tv: 200,
    watch: 60
  }
  return deviceSizes[props.deviceType] || 100
}

// Return inline style object for background-based preview when wallpaperId is not provided
const getBackgroundStyle = () => {
  if (!props.wallpaper) return {}
  if (props.fitOption === 'tile') {
    const size = getTileSize()
    return {
      backgroundImage: `url(${props.wallpaper})`,
      backgroundRepeat: 'repeat',
      backgroundSize: `${size}px ${size}px`,
      backgroundPosition: 'top left'
    }
  }
  if (props.fitOption === 'center') {
    return {
      backgroundImage: `url(${props.wallpaper})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto',
      backgroundPosition: 'center'
    }
  }
  // Default: cover or contain depending on device type heuristics
  const contains = ['laptop','desktop','ultrawide','tv'].includes(props.deviceType)
  return {
    backgroundImage: `url(${props.wallpaper})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: contains ? 'contain' : 'cover',
    backgroundPosition: 'center'
  }
}
</script>

<style scoped>
.device-mockup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.device-mockup {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  will-change: transform;
}

.device-mockup:hover {
  transform: translateY(-2px);
}

.device-mockup:active {
  transform: translateY(0);
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .device-mockup-container {
    padding: 0.5rem;
  }
}
</style>